import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  IonicPage,
  Content,
  NavController,
  NavParams,
  Platform,
  AlertController,
  ActionSheetController,
  LoadingController,
  ToastController
} from "ionic-angular";
import { Camera } from "@ionic-native/camera";
import { Keyboard } from "ionic-angular";
import { Base64ToGallery } from "@ionic-native/base64-to-gallery";
import { AndroidPermissions } from "@ionic-native/android-permissions";
// import { File } from '@ionic-native/file';
// import { Transfer, TransferObject } from '@ionic-native/transfer';
// import { FilePath } from '@ionic-native/file-path';
import { MockupProvider } from "../../providers/mockup/mockup";
import { StorageProvider } from "../../providers/storage/storage";
import { ModelsProvider } from "../../providers/models/models";
// import { LayoutsProvider } from "../../providers/layouts/layouts";
import { SizesProvider } from "../../providers/sizes/sizes";
import { BackgroundsProvider } from "../../providers/backgrounds/backgrounds";

import { TranslateService } from "@ngx-translate/core";
/**
 * Class EditorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-editor",
  templateUrl: "editor.html"
})
export class EditorPage {
  // picture : any = null;
  @ViewChild("file") fileInput: ElementRef;
  @ViewChild(Content) content: Content;
  fileToUpload: File = null;
  layers:any = null;
  mockup:any = null;
  layer_selected:any = 0;
  texts:any = null;
  text_selected:any = 0;
  template:any = null;
  size:any = null;
  preview:any = null;
  background:any = {
    color: "#FFFFFF",
    color_secondary: "#000000",
    opacity: 100,
    opacity_secondary: 50,
    type: null
  };
  text:any = {
    title: null,
    fontSize: 50,
    position: {
      vertical: 100,
      horizontal: 100
    },
    color: "#000000",
    align: "center"
  };

  all_models: any = [];
  model_category: any = "crop";
  categories_models: any = [];
  finalPicture: any = null;
  device_selected: any = "0";
  viewport: any = {
    width: null,
    height: null
  };
  pictures: any = [];
  picture_copyright: any;
  background_pictures: any = [];
  model_pictures: any = [];
  loading: any = null;
  // position : any = 0;
  colors: any = [];
  backgrounds: any = [];
  sizes: any = [];
  canvas: any = {
    width: null,
    height: null
  };
  canvas_ctx: any;
  i18n: string[] = [];
  edited: boolean = false;
  keyboard_open: boolean = false;
  show_model_container: boolean = false;
  options: any = "device";
  options_modal: any = null;
  grid = false;
  custom_color = "#c4c4c4";
  imageLoaded: any = 0;

  constructor(
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private navParams: NavParams,
    private camera: Camera,
    private translate: TranslateService,
    public keyboard: Keyboard,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private androidPermissions: AndroidPermissions,
    private platform: Platform,
    private base64ToGallery: Base64ToGallery,
    private loadingCtrl: LoadingController,
    private mockupProvider: MockupProvider,
    private storageProvider: StorageProvider,
    private modelsProvider: ModelsProvider,
    private backgroundsProvider: BackgroundsProvider,
    private sizesProvider: SizesProvider
  ) {
    this.layers = this.navParams.get("layers");
    this.texts = this.navParams.get("texts");
    this.size = this.navParams.get("size");
    this.background = this.navParams.get("background");
    console.log("layer : ",this.layers);
    console.log("texts : ",this.texts);

    this.translate
      .get([
        "PICTURE_ADDED_TO_GALLERY",
        "EXPORT_IN_PROGRESS",
        "TITLE_ALERT_LEAVE",
        "MESSAGE_ALERT_LEAVE",
        "SAVE",
        "LEAVE_WITHOUT_SAVE",
        "OK",
        "YES",
        "NO",
        "CANCEL",
        "TITLE",
        "SUBTITLE",
        "DEMO_PICTURE",
        "LOAD_FROM_LIBRARY",
        "LOAD_FROM_COMPUTER",
        "USE_CAMERA"
      ])
      .subscribe(value => {
        this.i18n = value;
        this.setTexts();
      });

    this.platform.ready().then(readySource => {
      this.viewport = {
        width: this.platform.width(),
        height: this.platform.height()
      };

      if (this.platform.is("android")) {
        // console.log("platform android");
        this.androidPermissions
          .checkPermission(
            this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
          )
          .then(
            result => {
              // console.log('Has permission?',result.hasPermission);
              if (!result.hasPermission)
                this.androidPermissions.requestPermissions([
                  this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
                ]);
            },
            err => {
              console.log("Err", err);
              this.androidPermissions.requestPermissions([
                this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
              ]);
            }
          );
      }
    });
  }

  setModelCategory(category) {
    this.model_category = category;
  }
  setBlur() {
    if (this.platform.is("cordova")) return;
    this.keyboard_open = false;
  }
  setFocus() {
    setTimeout(() => {
      // this.content.resize();
      this.content.scrollToTop();
    }, 500);
    if (this.platform.is("cordova")) return;
    this.keyboard_open = true;
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad EditorPage');
  }
  ionViewDidEnter() {
    this.all_models = this.modelsProvider.getAllModels();
    this.categories_models = Object.keys(this.all_models);
    // console.log("this.all_models", this.all_models);
    this.canvas = document.getElementById("canvas");
    this.canvas_ctx = this.canvas.getContext("2d");
    this.setSizes();
    this.setColors();
    this.setBackgrounds();
    this.updateCanvas();
  }

  toogleModelContainer(){
    this.show_model_container = !this.show_model_container;
    this.model_category = this.layers[this.layer_selected].model.type;
  }

  async updateCanvas() {
    this.picture_copyright = await this.loadImage('assets/imgs/copyright.png');
    let i = 0;
    for(let layer of this.layers){
      if (layer.picture != null)
        this.pictures[i] = await this.loadImage(layer.picture["contenu"]);
      else
        this.pictures[i] = null;
      if (layer.color != null)
        this.model_pictures[i] = await this.loadImage(layer.color.src);
      else
        this.model_pictures[i] = null;
      i++;
    }

    this.draw();
  }
  showPreview() {
    this.generatePreview();
    setTimeout(function() {
      // console.log(document.getElementById("preview_picture"));
      document.getElementById("preview_picture").click();
    }, 300);
  }
  async loadImage(src) {
    let img = new Image();
    // img.onload = this.draw();
    img.src = src;
    img.onload = () => {
        this.draw();
    };
    return img;
  }

  deleteLayout() {
    this.pictures[this.layer_selected].picture = null;
    this.pictures[this.layer_selected] = null;
    this.layers[this.layer_selected].picture = null;
    this.draw();
  }

  async save(pop = true) {
    await this.generatePreview();
    this.storageProvider
      .addScreenshot({layers:this.layers, background: this.background, size: this.size, texts:this.texts, preview:this.preview})
      .then(project => {
        this.edited = false;
        // if(pop)
        this.navCtrl.popTo(this.navCtrl.getByIndex(0));
      })
      .catch(err => {
        console.log(err);
      });
  }

  async generatePreview() {
    let dt = await this.canvas.toDataURL("image/png");
    // console.log("generatePreview",dt.length);
    dt = dt.replace("data:image/png;base64,", "");
    this.preview = this.getPicture(dt);
  }

  export() {
    this.generatePreview();
    setTimeout(() => {
      if (this.platform.is("cordova")) {
        this.presentLoading(this.i18n["EXPORT_IN_PROGRESS"]);
        this.base64ToGallery
          .base64ToGallery(this.preview.contenu)
          .then(
            res => {
              // console.log("export : base64ToGallery res");
              this.hideLoading();
              this.presentToast(this.i18n["PICTURE_ADDED_TO_GALLERY"]);
              // console.log('Saved image to gallery ', res)
            },
            err => {
              // console.log("export : base64ToGallery res");
              this.hideLoading();
              this.presentToast("Error saving image to gallery : " + err);
              console.log("Error saving image to gallery ", err);
            }
          );
      } else {
        this.exportWeb();
      }
    }, 300);
  }

  exportWeb() {
    // console.log("exportWeb", this.preview.contenu);
    let dt = this.preview.contenu;
    /* Change MIME type to trick the browser to downlaod the file instead of displaying it */
    dt = dt.replace(/^data:image\/[^;]*/, "data:application/octet-stream");

    /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
    dt = dt.replace(
      /^data:application\/octet-stream/,
      "data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png"
    );

    let a = document.createElement("a");
    a.href = dt;
    let date =
      new Date().getUTCDate().toString() +
      "_" +
      new Date().getUTCMonth().toString() +
      "_" +
      new Date().getUTCFullYear().toString();
    a.download = this.layers[this.layer_selected].model.name + "_" + date + ".png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  draw(){
    this.imageLoaded += 1;
    // console.log("draw",this.pictures);

    // Couleur de base
    this.canvas_ctx.fillStyle = "#FFFFFF";
    this.canvas_ctx.globalAlpha = 1;
    this.canvas_ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    // Couleur de fond
    this.canvas_ctx.fillStyle = this.background.color;
    this.canvas_ctx.globalAlpha = this.background.opacity / 100;
    this.canvas_ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.canvas_ctx.globalAlpha = 1;
    this.canvas_ctx.imageSmoothingEnabled = true;


    //Background
    if (this.background.type != null) {
      if (this.background.type.category == "gradient") {
        let params = this.background.type.params;
        let grd = null;
        if (this.background.type.subcategory == "radial_gradient") {
          grd = this.canvas_ctx.createRadialGradient(
            this.canvas.max / 2,
            this.canvas.max / 2,
            5,
            this.canvas.max / 2,
            this.canvas.max / 2,
            this.canvas.max
          );
        }
        if (this.background.type.subcategory == "linear_gradient") {
          grd = this.canvas_ctx.createLinearGradient(
            this.canvas.max * params.x0,
            this.canvas.max * params.y0,
            this.canvas.max * params.x1,
            this.canvas.max * params.y1
          );
        }
        grd.addColorStop(0, this.background.color_secondary);
        grd.addColorStop(1, this.background.color);
        this.canvas_ctx.fillStyle = grd;
        this.canvas_ctx.globalAlpha =
        this.background.opacity_secondary / 100;
        this.canvas_ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.canvas_ctx.globalAlpha = 1;
      }
    }


    console.log("this.layers",this.layers);
    let layer_index = 0;
    for (let layer of this.layers) {


      // Gestion des marges
      let spacew =
        this.canvas.max -
        this.canvas.max *
          (layer.layout.zoom/100 +
            (1 - this.canvas.width / this.canvas.height));
      let spaceh =
        this.canvas.max -
        this.canvas.max *
          (layer.layout.zoom/100 +
            (1 - this.canvas.width / this.canvas.height));
      // console.log("spacew",spacew);
      // console.log("spaceh",spaceh);
      let layout_margin = {
        horizontal:(layer.layout.margin.horizontal==-100?1:((layer.layout.margin.horizontal+100)/100)),
        vertical:(layer.layout.margin.vertical==-100?1:((layer.layout.margin.vertical+100)/100)),
      }
      // console.log("layout_margin", layout_margin);
      // console.log("spacew",spacew);
      // console.log("spaceh",spaceh);

      let margin = {
        left:
          ((this.canvas.width * layout_margin.horizontal ) / 2) -
          (spacew * layer.model.size.ratio) / 2,
        right:
          this.canvas.width -
          ((this.canvas.width *  layout_margin.horizontal) / 2) +
          (spacew * layer.model.size.ratio) / 2,
        top:
          ((this.canvas.height * layout_margin.vertical) / 2) -
          spaceh / 2,
        bottom:
          this.canvas.height -
          ((this.canvas.height * layout_margin.vertical) / 2) -
          spaceh / 2,
        width: spacew,
        height: spaceh,
        border_right: layer.model.border.right / layer.model.size.width,
        border_bottom: layer.model.border.bottom / layer.model.size.height
      };

      let border = {
        left:
          layer.model.border.left *
          (spacew / this.canvas.max) *
          (this.canvas.height / layer.model.size.height),
        right:
          layer.model.border.right *
          (spacew / this.canvas.max) *
          (this.canvas.height / layer.model.size.height),
        top:
          layer.model.border.top *
          (spaceh / this.canvas.max) *
          (this.canvas.height / layer.model.size.height),
        bottom:
          layer.model.border.bottom *
          (spaceh / this.canvas.max) *
          (this.canvas.height / layer.model.size.height)
      };

      // console.log("margin.top (" + layer_index + ")",margin.top);
      // console.log("margin.left (" + layer_index + ")",margin.left);
      // console.log("border",border);
      let imageWidth =
        margin.height * layer.model.size.ratio - border.left - border.right;
      let imageHeight = margin.height - border.top - border.bottom;

      if(this.layer_selected == layer_index)
        this.mockup = {
          width:imageWidth,
          height: imageHeight
        };
      // Save / Translate / Rotate
      this.canvas_ctx.save();
      this.canvas_ctx.translate(margin.left + border.left + imageWidth/2, margin.top + border.top + imageHeight/2);
      this.canvas_ctx.rotate((layer.layout.rotate * Math.PI) / 180);



      // Image phone
      if (layer.color.type != 'clear' && (layer.model.name == 'iphonexborder' ||layer.model.name == 'ipad_pro_border' || layer.model.name == 'ipad_border' )) {
        this.canvas_ctx.drawImage(
          this.model_pictures[layer_index],
          -(imageWidth/2),
          -(imageHeight/2),
          margin.height * layer.model.size.ratio,
          margin.height
        );
      }

      // Crop
      if (layer.model.crop != null) {
        if (layer.model.crop == "ios_icon")
          this.roundedIcon(
            -imageWidth/2 + border.left,
            -imageHeight/2 + border.top,
            imageWidth,
            imageHeight,
            (10 / 57) * imageWidth
          );
        if (layer.model.crop == "iphone")
          this.roundedImage(
            -imageWidth/2 + border.left,
            -imageHeight/2 + border.top,
            imageWidth,
            imageHeight,
            (0.2 / 10) * imageWidth
          );
        if (layer.model.crop == "rectangle")
          this.roundedImage(
            -imageWidth/2 + border.left,
            -imageHeight/2 + border.top,
            imageWidth,
            imageHeight,
            (0.01 / 10) * imageWidth
          );
        if (layer.model.crop == "iphone_x")
          this.notchImage(
            -imageWidth/2 + border.left,
            -imageHeight/2 + border.top,
            imageWidth,
            imageHeight
          );

        if (layer.model.crop == "ipad_pro")
        this.roundedImage(
          -imageWidth/2 + border.left,
          -imageHeight/2 + border.top,
          imageWidth,
          imageHeight,
          (0.3 / 10) * imageWidth
        );

          this.canvas_ctx.clip();
      }


      // Picture inside
      if (this.pictures[layer_index] != null) {
        console.log("drawImage picture",layer.picture);
        this.canvas_ctx.drawImage(
          this.pictures[layer_index],
          -(imageWidth/2) + border.left,
          -(imageHeight/2) + border.top,
          imageWidth,
          imageHeight
        );
        // console.log("Image screenshot width",imageWidth);
        // console.log("Image screenshot height",imageHeight);
      } else {
        this.canvas_ctx.fillStyle = "rgb(216,216,216)";
        this.canvas_ctx.fillRect(
          -(imageWidth/2) + border.left,
          -(imageHeight/2) + border.top,
          imageWidth,
          imageHeight
        );
      }


      // Text preview
      if (layer.picture == null) {
        let fontSize =
          (imageWidth > imageHeight ? imageWidth : imageHeight) / 8;
        let margin_text = fontSize / 10;
        this.canvas_ctx.font = "bold " + fontSize + "px  Arial";
        this.canvas_ctx.fillStyle = "#717171";
        this.canvas_ctx.textAlign = "center";
        let text_position = {
          x: (border.left/2)*1.10,
          y: (border.top/2)*1.10
        };
        // console.log("text_position", text_position);
        this.canvas_ctx.fillText(
          layer.model.size.width,
          text_position.x + margin_text,
          (text_position.y - fontSize) * 0.80
        );
        this.canvas_ctx.fillText(
          "x",
          text_position.x + margin_text,
          text_position.y
        );
        this.canvas_ctx.fillText(
          layer.model.size.height,
          text_position.x + margin_text,
          text_position.y + fontSize
        );
      }


      // Image phone
      if (layer.color.type != 'clear' && (layer.model.name != 'iphonexborder' && layer.model.name != 'ipad_pro_border' && layer.model.name != 'ipad_border' )) {
        this.canvas_ctx.drawImage(
          this.model_pictures[layer_index],
          -(imageWidth/2),
          -(imageHeight/2),
          margin.height * layer.model.size.ratio,
          margin.height
        );
      }
      // else {
      //   console.log("il faut supprimer l'ancienne image");
      // }

      //END OF LOOP
      this.canvas_ctx.restore();
      layer_index++;
    }


    // Text
    for (let text of this.texts) {
      if (text.value != "") {
        this.canvas_ctx.save();
        this.canvas_ctx.font = text.fontSize + "px " + text.fontFamily;
        this.canvas_ctx.fillStyle = text.color;
        this.canvas_ctx.textAlign = "center"; //this.text.align;


        let text_margin = {
          horizontal:(text.position.horizontal==-100?1:((text.position.horizontal+100)/100)),
          vertical:(text.position.vertical==-100?1:((text.position.vertical+100)/100)),
        };
        console.log("text_margin", text_margin);
        // console.log("spacew",spacew);
        // console.log("spaceh",spaceh);

        let text_position = {
          x:((this.canvas.width * text_margin.horizontal ) / 2),
          y:((this.canvas.height * text_margin.vertical ) / 2)
        };


        this.canvas_ctx.translate(text_position.x,text_position.y);
        this.canvas_ctx.rotate((text.rotate * Math.PI) / 180);

        // let text_position = {
        //   x: (this.canvas.width / 2) * text.position.horizontal,
        //   y: (this.canvas.height / 2) * text.position.vertical
        // };
        // console.log("draw text :", text);
        // console.log("draw text position", text_position);
        this.canvas_ctx.fillText(
          text.value,
          0,
          text.fontSize/4,
        );

        this.canvas_ctx.restore();
      }
    }
    // if(this.text.subtitle != ""){
    //   this.canvas_ctx.font = "80px Roboto";
    //   this.canvas_ctx.fillStyle = this.text.color;
    //   this.canvas_ctx.textAlign = this.text.align;
    //   this.canvas_ctx.fillText(this.text.subtitle, position_x,  position_y + 50 + 100);
    // }


    //Copyright 

    this.canvas_ctx.drawImage(
      this.picture_copyright,
      10,
      this.canvas.height - 100,
      240,
      90
    );

    // Draw grid
    if (this.grid) {
      let cut = 6;
      for (let i = 1; i <= cut; i++) {
        this.canvas_ctx.moveTo((i * this.canvas.width) / cut, 0);
        this.canvas_ctx.lineTo(
          (i * this.canvas.width) / cut,
          this.canvas.height
        );
      }

      for (let i = 1; i <= cut; i++) {
        this.canvas_ctx.moveTo(0, (i * this.canvas.height) / cut);
        this.canvas_ctx.lineTo(
          this.canvas.width,
          (i * this.canvas.height) / cut
        );
      }

      this.canvas_ctx.strokeStyle = "lightgray";
      this.canvas_ctx.lineWidth = 4;
      this.canvas_ctx.stroke();
    }

    // this.canvas_ctx.globalAlpha = 0.5;
  }

  toogleGrid() {
    this.grid = !this.grid;
    this.draw();
  }

  setOptionsModal(type){
    console.log("setOptionsModal",type);
    this.options_modal = type;
  }

  setOptions(type) {
    console.log("setOptions",type);
    if (this.options != null && this.options == type) {
      this.options = null;
    } else {
      if (type == null) {
        if (this.options_modal == "color_picker") this.options = "color";
        else if (this.options_modal == "color_picker_secondary")
          this.options = "layout";
        else if (this.options_modal == "color_picker_text") this.options = "text";
        else this.options = type;
      } else this.options = type;
    }
    this.options_modal = null;
    this.content.resize();
  }

  presentActionSheet() {
    let button_library = {
      text: this.i18n["LOAD_FROM_LIBRARY"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    };
    let button_camera = {
      text: this.i18n["USE_CAMERA"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    };
    let button_import_web = {
      text: this.i18n["LOAD_FROM_COMPUTER"],
      handler: () => {
        this.triggerFileInputClick();
      }
    };
    let button_cancel = {
      text: this.i18n["CANCEL"],
      role: "cancel"
    };
    let button_demo = {
      text: this.i18n["DEMO_PICTURE"],
      handler: () => {
        this.takeDemoPicture();
      }
    };
    let buttons = [button_demo, button_import_web, button_cancel];
    if (this.platform.is("cordova"))
      buttons = [button_demo, button_library, button_camera, button_cancel];

    let titletext = this.i18n["SELECT_PICTURE"];
    // console.log("titletext",titletext);
    let actionSheet = this.actionSheetCtrl.create({
      title: titletext,
      buttons: buttons
    });
    actionSheet.present();
  }

  takeDemoPicture() {
    this.mockupProvider
      .getImageDemo(this.mockup.width,this.mockup.height)
      .then(dataUrl => {
        // console.log("takeDemoPicture success");
        let picture = this.getPicture(dataUrl);
        this.layers[this.layer_selected].picture = picture;
        this.updateCanvas();
        this.edited = true;
      })
      .catch(err => {
        console.error("error loading takeDemoPicture", err);
      });
  }
  takePicture(sourceType) {
    var options = {
      quality: 100,
      sourceType: sourceType,
      targetWidth:1024,
      targetHeight:1024,
      allowEdit: true,
      destinationType: this.camera.DestinationType.DATA_URL,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      dataUrl => {
        // console.log("takePicture",dataUrl);
        let picture = this.getPicture(dataUrl);
        this.layers[this.layer_selected].picture = picture;
        this.updateCanvas();
        this.edited = true;
      },
      err => {
        this.presentToast("Error while selecting image.");
      }
    );
  }

  getPicture(dataUrl) {
    let picture_name = new Date().getTime();
    let picture = {
      title: picture_name,
      contenu: "data:image/png;base64," + dataUrl,
      type: "image/jpeg"
    };
    return picture;
  }

  showPrompt() {
    const prompt = this.alertCtrl.create({
      title: "Choose color",
      message: "Entrer le code hexadécimal",
      inputs: [
        {
          name: "custom_color",
          placeholder: "#C4C4C4"
        }
      ],
      buttons: [
        {
          text: "Cancel",
          handler: data => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Save",
          handler: data => {
            // console.log("data.color",data);
            this.custom_color = data.custom_color;
            this.setColor(data.custom_color);
            // console.log('Saved clicked');
          }
        }
      ]
    });
    prompt.present();
  }

  addText(){
    this.texts.push({
      value:'Texte ' + (this.texts.length+1),
      fontSize:40,
      color:"#000000",
      position: {
        horizontal: 0,
        vertical : 0
      },
      rotate: 0
    });
    this.draw();
    this.edited = true;
    this.text_selected = this.texts.length-1;
    console.log("this.texts",this.texts);
    console.log("this.text_selected",this.text_selected);
  }

  textSegmentChanged(i){
    // console.log("i : " + i)
    // console.log("this.text_selected",this.text_selected);
    this.text_selected = i;
  }

  setTexts() {
    if (this.text.title == null)
      this.text.title = "";
  }
  setFontSize() {
    this.draw();
    this.edited = true;
  }
  setText() {
    this.draw();
    this.edited = true;
  }
  setTextAlign(align) {
    this.text.align = align;
    this.draw();
    this.edited = true;
  }
  setTextColor(color) {
    this.text.color = color;
    this.draw();
    this.edited = true;
  }
  setTextPosition() {
    this.draw();
    this.edited = true;
  }
  setOpacity() {
    this.draw();
    this.edited = true;
  }
  setOpacitySecondary() {
    this.draw();
    this.edited = true;
  }
  setLayoutPosition() {
    this.draw();
    this.edited = true;
  }
  setZoom() {
    this.draw();
    this.edited = true;
  }
  setColor(color) {
    if (!/^#[0-9A-F]{6}$/i.test(color)) return;
    this.background.color = color;
    this.draw();
    this.edited = true;
  }
  setColorSecondary(color) {
    if (!/^#[0-9A-F]{6}$/i.test(color)) return;
    this.background.color_secondary = color;
    this.draw();
    this.edited = true;
  }
  setColorText(color) {
    if (!/^#[0-9A-F]{6}$/i.test(color)) return;
    this.text.color = color;
    this.draw();
    this.edited = true;
  }
  setColors() {
    let colors = [];
    let colors_list = [
      "#FFFFFF",
      "#FDF6F7",
      "#E5EFFC",
      "#E0E4EB",
      "#C5CCD9",
      "#5C748D",
      "#36393E",
      "#212121",
      "#FEE94E",
      "#FD9827",
      "#F1463E",
      "#E72565",
      "#9B2FAE",
      "#683FB4",
      "#4054B2",
      "#1972F5",
      "#2B98F0",
      "#159688",
      "#357538",
      "#9F8D85",
      "#7D5D4F",
      "#9E9E9E",
    ];

    for (let color of colors_list) {
      let type = "colored";
      if (color == "#000000") type = "black";
      if (color == "#FFFFFF" || color == "#FDF6F7" || color == "#E5EFFC"  || color == "#C5CCD9" || color == "#E0E4EB" || color == "#FDF6F7") type = "white";
      colors.push({
        code: color,
        type: type
      });
    }

    this.colors = colors;
  }

  setModelColor(color) {
    // console.log("setModelColor",index);
    this.layers[this.layer_selected].color = color;
    this.updateCanvas();
    this.draw();
    this.edited = true;
  }

  setModelCustom(model) {
    this.layers[this.layer_selected].model = model;
    // if(this.layers[this.layer_selected].model.colors.length > 1)
      this.layers[this.layer_selected].color =  this.layers[this.layer_selected].model.colors[0];
    // this.setModel();
    this.updateCanvas();
  }
  setModel(model) {
      this.layers[this.layer_selected].model = model;
      this.layers[this.layer_selected].color =  this.layers[this.layer_selected].model.colors[0];
  }

  setBackgrounds() {
    this.backgrounds = this.backgroundsProvider.getBackgrounds();
    if (!this.background.type)
      this.background.type = this.backgrounds[0];
  }

  setBackground(index) {
    this.background.type = this.backgrounds[index];
    this.draw();
    this.edited = true;
  }

  setSizes() {
    this.sizes = this.sizesProvider.getSizes();

    // Si c'est un nouveau screenshot, on definit la couleur 0 par defaut.
    if (!this.size)
      this.size = this.sizes[0];

    let sizeIndex = this.sizes.findIndex((size) => {
      return size.class == this.size.class;
    });

    this.canvas.width = this.sizes[sizeIndex]["width"];
    this.canvas.height = this.sizes[sizeIndex]["height"];
    this.canvas.max =
      this.canvas.width > this.canvas.height
        ? this.canvas.width
        : this.canvas.height;
  }

  setSize(index) {
    // let zoom_comparaison_width = this.sizes[index].width/this.canvas.width;
    // let zoom_comparaison_height = this.sizes[index].height/this.canvas.height;
    // let zoom_comparaison_max = zoom_comparaison_width < zoom_comparaison_height?zoom_comparaison_width:zoom_comparaison_height;
    // if(zoom_comparaison_width != 1){

    //   for(let layer of this.layers){
    //     layer.layout.zoom = layer.layout.zoom*zoom_comparaison_width;
    //     // layer.layout.margin.horizontal = layer.layout.margin.horizontal*zoom_comparaison_width;
    //     // layer.layout.margin.vertical = layer.layout.margin.vertical*zoom_comparaison_width;
    //   }
    //   for(let text of this.texts){
    //     text.fontSize = text.fontSize*zoom_comparaison_width;
    //   }
    // }
    // console.log("zoom_comparaison_width : ", zoom_comparaison_width);
    // console.log("zoom_comparaison_height : ", zoom_comparaison_height);
    // console.log("zoom_comparaison_max : ", zoom_comparaison_max);
    this.size = this.sizes[index];
    
    this.canvas.width = this.sizes[index]["width"];
    this.canvas.height = this.sizes[index]["height"];
    this.canvas.max =
      this.canvas.width > this.canvas.height
        ? this.canvas.width
        : this.canvas.height;
    this.draw();
    this.edited = true;
  }

  addDevice(){
    // let iphone_x = this.modelsProvider.getModel(
    //   'phones',
    //   1
    // );
    // let layout_center = this.layoutsProvider.getLayout(
    //   "phones",
    //   0
    // );
    let layers = JSON.parse(JSON.stringify(this.layers));
    layers.push(this.layers[this.layers.length-1]);
    this.layers = [];
    console.log("layers",layers);
    this.layers = layers;

  }
  setLayerSelected(i){
    console.log("setLayerSelected",i)
    // this.options = "device";
    console.log("this.options",this.options);
    this.layer_selected = i;

  }

  presentLoading(content = "Please wait...") {
    this.loading = this.loadingCtrl.create({
      content: content
    });

    this.loading.present();
  }

  hideLoading() {
    this.loading.dismiss();
  }

  ionViewCanLeave() {
    if (this.edited) {
      return new Promise((resolve, reject) => {
        this.save(false);
        resolve();
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve();
      });
    }
  }
  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "top"
    });

    toast.onDidDismiss(() => {
      console.log("Dismissed toast");
    });

    toast.present();
  }
  // Roundr / notch
  roundedIcon(x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.canvas_ctx.beginPath();
    this.canvas_ctx.moveTo(x + r, y);
    this.canvas_ctx.arcTo(x + w, y, x + w, y + h, r);
    this.canvas_ctx.arcTo(x + w, y + h, x, y + h, r);
    this.canvas_ctx.arcTo(x, y + h, x, y, r);
    this.canvas_ctx.arcTo(x, y, x + w, y, r);
    this.canvas_ctx.closePath();
    return;
  }

  roundedImage(x, y, w, h, r) {
    this.canvas_ctx.beginPath();
    this.canvas_ctx.moveTo(x + r, y);
    this.canvas_ctx.lineTo(x + w - r, y);
    this.canvas_ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    this.canvas_ctx.lineTo(x + w, y + h - r);
    this.canvas_ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    this.canvas_ctx.lineTo(x + r, y + h);
    this.canvas_ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    this.canvas_ctx.lineTo(x, y + r);
    this.canvas_ctx.quadraticCurveTo(x, y, x + r, y);
    this.canvas_ctx.closePath();
    return;
  }

  notchImage(x, y, width, height) {
    // let width = 750;//375;
    // let height = 1624;//812;
    // console.log("notchImage",x,y,width,height);
    let b = {
      x: (12 / 375) * width,
      y: (12 / 375) * width,
      radius: (6 / 375) * width
    };
    let c = {
      x: (83 / 375) * width,
      y: (83 / 375) * width,
      radius: (20 / 375) * width
    };
    let radius = (40 / 375) * width;

    this.canvas_ctx.beginPath();
    this.canvas_ctx.moveTo(radius + x, y);
    //line left
    this.canvas_ctx.lineTo(c.x - b.radius + x, y);
    //b left
    this.canvas_ctx.quadraticCurveTo(c.x + x, y, c.x + x, b.radius + y);
    //c left
    this.canvas_ctx.quadraticCurveTo(
      c.x + x,
      y + (c.radius + b.radius * 1.5),
      c.x + c.radius + x,
      c.radius + b.radius * 2 + y
    );

    //line middle
    this.canvas_ctx.lineTo(
      width - c.x - c.radius + x,
      c.radius + b.radius * 2 + y
    );

    // c right
    this.canvas_ctx.quadraticCurveTo(
      width - c.x + x,
      y + (c.radius + b.radius * 1.5),
      width - c.x + x,
      b.radius + y
    );
    //b right
    this.canvas_ctx.quadraticCurveTo(
      width - c.x + x,
      y,
      width - c.x + b.radius + x,
      y
    );
    //line right
    this.canvas_ctx.lineTo(width - radius + x, y);

    //Top right
    this.canvas_ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    this.canvas_ctx.lineTo(x + width, y + height - radius);

    //Bottom right
    this.canvas_ctx.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
    );
    this.canvas_ctx.lineTo(x + radius, y + height);

    //Bottom left
    this.canvas_ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    this.canvas_ctx.lineTo(x, y + radius);
    //Top left
    this.canvas_ctx.quadraticCurveTo(x, y, x + radius, y);
    this.canvas_ctx.closePath();
  }

  // Gestion web
  triggerFileInputClick() {
    this.fileInput.nativeElement.click();
  }

  onFileInputChange(files: FileList) {
    this.fileToUpload = files.item(0);

    if (this.fileInput.nativeElement.value != "") {
      // console.log('onFileInputChange', this.fileInput.nativeElement.value);
      // console.log('this.fileToUpload', this.fileToUpload);
      this.fileToBase64(this.fileToUpload);
      // this.upload();
    }
  }

  fileToBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = e => {
      // console.log(reader.result);
      //
      //  // Génération
      let data = reader.result.toString();
      data = data.replace("data:image/png;base64,", "");
      data = data.replace("data:image/jpeg;base64,", "");
      data = data.replace("data:image/jpg;base64,", "");
      data = data.replace("data:image/webp;base64,", "");
      data = data.replace("data:image/gif;base64,", "");
      let picture = this.getPicture(data);
      // console.log("fileToBase64", picture);
      this.layers[this.layer_selected].picture = picture;
      this.updateCanvas();
    };
    reader.onerror = error => {
      console.log("Error: ", error);
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/editor/editor.ts